/* tslint:disable */

/**
 */
export class ConnectionUser {
    ID_USER?: number;
    DATE_CONNECTION?: string;
    DATE_DISCONNECTION?: string;
    TYPE_DISCONNECTION?: string;
    USERNAM?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/connection-user.ts